import styled from '@emotion/styled';

const StyledFieldName = styled('h4')({
  marginBottom: 0,
  marginRight: 'auto',
  cursor: 'pointer'
});

export default StyledFieldName;
